



export class OrganisationDashboardVM {
    
    availableCredits?: number;
    
    totalIssued25min?: number;
    
    totalIssued50min?: number;
    
    totalIssued80min?: number;
    
    totalUsed25min?: number;
    
    totalUsed50min?: number;
    
    totalUsed80min?: number;
    
}
